module.exports = __webpack_public_path__ + "img/items.553654ee.svg";